import * as Yup from 'yup'

import flow from 'lodash/fp/flow'

import equal from '@galo-monitor/forms/validators/equal.validator'
import password from '@galo-monitor/forms/validators/password.validator'
import required from '@galo-monitor/forms/validators/required.validator'

const userProfileSchema = ({ t, data }) => Yup.object().shape({
  password_old: flow(
    password({ t }),
    required({ t })
  )(Yup.string()),
  password: flow(
    password({ t }),
    required({ t })
  )(Yup.string()),
  password_confirmation: flow(
    equal({ t, text: 'passwords do not match', compareWith: data.password }),
    required({ t })
  )(Yup.string())
})

export default userProfileSchema
